import { Breadcrumb } from './Breadcrumb';
import styles from './PageHeader.module.css';

interface PageHeaderProps {
	title: string;
	breadcrumbs?: Array<{ label: string; href?: string }>;
	actions?: React.ReactNode;
}

export function PageHeader({ title, breadcrumbs, actions }: PageHeaderProps) {
	return (
		<div className={styles.header}>
			{breadcrumbs && breadcrumbs.length > 0 && (
				<div className={styles.breadcrumbRow}>
					<Breadcrumb items={breadcrumbs} />
				</div>
			)}
			<div className={styles.titleRow}>
				<h1 className={styles.title}>{title}</h1>
				{actions && <div className={styles.actions}>{actions}</div>}
			</div>
			<div className={styles.divider} />
		</div>
	);
}
